module.exports = __webpack_public_path__ + "static/media/uiux.d203b95c.png";